import React from 'react';
import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Helmet } from 'react-helmet-async';

const FAQSection = ({ faqs, title = 'Preguntas frecuentes' }) => {
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <Box sx={{ my: 4 }}>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(faqSchema)}
        </script>
      </Helmet>

      <Typography
        variant="h4"
        sx={{ fontWeight: 600, color: '#1A1A1A', mb: 3 }}
      >
        {title}
      </Typography>

      {faqs.map((faq, index) => (
        <Accordion
          key={index}
          sx={{
            mb: 1,
            '&:before': { display: 'none' },
            boxShadow: '0 1px 8px rgba(0,0,0,0.06)',
            borderRadius: '10px !important',
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{ color: '#1E3A5F' }} />}
            sx={{
              '& .MuiAccordionSummary-content': { my: 1.5 },
            }}
          >
            <Typography sx={{ fontWeight: 600, color: '#1A1A1A' }}>
              {faq.question}
            </Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ pt: 0, pb: 2 }}>
            <Typography variant="body1" sx={{ color: '#1A1A1A', lineHeight: 1.7 }}>
              {faq.answer}
            </Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
};

export default FAQSection;
